import { render, staticRenderFns } from "./PlayerOnlineStatus.vue?vue&type=template&id=5ae7f71d&scoped=true&"
import script from "./PlayerOnlineStatus.vue?vue&type=script&lang=js&"
export * from "./PlayerOnlineStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae7f71d",
  null
  
)

export default component.exports